import React, {Component} from 'react';
import {withRouter} from 'react-router-dom';
import OrganizationDetails from '../partials/forms/OrganizationDetails';
import '../css/challenge.css';
import {connect} from 'react-redux';

/**
 * Page: View Organization
 */
class XOrganizationView extends Component {
    constructor(props) {
        super(props);

        const pathArr = this.props.location.pathname.split('/');
        this.state = {
            pathArr: pathArr
        };
    }
    render() {
        const {user} = this.props;
        const {
            pathArr
        } = this.state;

        return (
            <>
                <div className="content xconnect challenge">
                    <h1 className="page-title">
                        Organization Overview
                    </h1>

                    <div className="panel no-padding">
                        <h3 className="header">Organization</h3>
                        <div className="row">
                            <div className="col col-xs-12">
                                <div className="form-container">
                                    <OrganizationDetails pathArr={pathArr} isSysop={user.is_sysop}/>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        user: state.user
    };
};

export default withRouter(
    connect(
    mapStateToProps
)(XOrganizationView));
